<template>
  <!-- 底部企业信息 -->
  <div>
    <el-container class="footer-section bg-dark">
      <el-row :gutter="60" class="footer-row">
        <el-col :span="6" class="footer-col">
          <div class="footer-block">
            <div class="footer-title">关于我们</div>
            <div class="footer-title-en">About Us on the website</div>
            <div class="footer-text footer-text-about">
              {{ companyInfo.about }}
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="footer-col">
          <div class="footer-block">
            <div class="footer-title">快速链接</div>
            <div class="footer-title-en">Quick Links</div>
            <ul class="quick-links">
              <li
                  v-for="(link, index) in quickLinks"
                  :key="index"
              >
                <a :href="link.url" :target="link.target">{{ link.text }}</a>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="6" class="footer-col">
          <div class="footer-block">
            <div class="footer-title">联系方式</div>
            <div class="footer-title-en">Contact Us</div>
            <div class="footer-text">
              邮箱：{{ companyInfo.email }}
            </div>
            <div class="footer-text">
              地址：{{ companyInfo.address }}
            </div>
          </div>
        </el-col>
<!--        <el-col :span="6" class="footer-col" v-if="companyInfo.wechat || companyInfo.weibo">-->
<!--          <div class="footer-block">-->
<!--            <div class="footer-title">关注我们</div>-->
<!--            <div class="footer-title-en">Follow Us</div>-->
<!--            <div class="qrcode-container">-->
<!--              <div class="qrcode-item" v-show="companyInfo.wechat">-->
<!--                <el-image-->
<!--                    style="width: 100%; height: 100%"-->
<!--                    :src="companyInfo.wechat"-->
<!--                    fit="contain"-->
<!--                >-->
<!--                </el-image>-->
<!--                <p class="qrcode-tip">微信公众号</p>-->
<!--              </div>-->
<!--              <div class="qrcode-item" v-show="companyInfo.weibo">-->
<!--                <el-image-->
<!--                    style="width: 100%; height: 100%"-->
<!--                    :src="companyInfo.weibo"-->
<!--                    fit="contain"-->
<!--                >-->
<!--                </el-image>-->
<!--                <p class="qrcode-tip">小程序</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-col>-->
      </el-row>
    </el-container>
    <div class="bottom-ui">
      © 2025 全国一体化算力网国家枢纽节点（长三角）算力公共服务平台
      版权所有 | 沪ICP备10216463号-2
    </div>
  </div>
</template>
<script>
import { infoServicePage } from "@/api";
export default {
  name: "Footer",
  data() {
    return {
      companyInfo: {
        about: "全国一体化算力网国家枢纽节点（长三角）算力公共服务平台致力于为区域数字经济发展提供强大的算力支持。",
        address: "上海市浦东新区张江金融科技园区",
        phone: "400-888-8888",
        email: "support@platform.com",
        wechat: "",
        weibo: "",
      },
      quickLinks: [
        { text: "平台介绍", url: "/platform", target: "_self" },
        // { text: "帮助中心", url: "/help", target: "_blank" },
      ],
    };
  },
  created() {
    this.getCompanyInfo();
  },
  methods: {
    async getCompanyInfo() {
      const res = await infoServicePage();
      if (res.code === 200) {
        if (res.data.records.length > 0)
          this.companyInfo = {
            ...this.companyInfo,
            ...res.data.records[0],
          };
      }
    },
  },
};
</script>
<style scoped lang="scss">
.bottom-ui {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #ffffff;
  // 替换为 Portal 主色调渐变
  background: linear-gradient(90deg, #057bf3 0%, #1a8cff 100%);
  border-top: 1px solid #2990f9;
  text-align: center;
  line-height: 1.6;
  position: relative;
  overflow: hidden;

  // 科技感光效线条 - 匹配主色
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, #fff, transparent);
    animation: lightMove 3s infinite linear;
  }
}

// 底部主区域 - 替换为 Portal 浅灰渐变风格
.footer-section {
  height: auto;
  min-height: 280px;
  box-sizing: border-box;
  padding: 40px 40px 30px;
  background: linear-gradient(to bottom, #f2f2f2, #fefefe);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;

  ::v-deep .footer-row {
    width: 100%;
    max-width: 1480px;
    display: flex !important;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 0 auto;
    position: relative;
    z-index: 1;
  }

  ::v-deep .footer-col {
    display: flex;
    justify-content: flex-start;
    flex: 0 0 auto;
    width: calc(25% - 30px);
    min-width: 220px;
    max-width: 300px;
    position: relative;

    // 科技感边框装饰 - 匹配 Portal 主色
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 40px;
      background: linear-gradient(180deg, #057bf3, #1a8cff);
      border-radius: 0 4px 4px 0;
      opacity: 0.8;
    }
  }

  }


.footer-block {
  width: 100%;
  padding: 15px;
  // 替换为 Portal 卡片背景色
  background: #f3f5f5;
  border-radius: 8px;
  // 匹配 Portal 边框色
  border: 1px solid #eef2f7;
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;

  &:hover {
    // 匹配 Portal hover 边框色
    border-color: #057bf3;
    box-shadow: 0 0 20px rgba(5, 123, 243, 0.1);
    transform: translateY(-2px);
  }
}

// 标题样式 - 匹配 Portal 文字色
.footer-title {
  font-size: 20px;
  color: #333333;
  margin-bottom: 8px;
  font-weight: 500;
  text-align: left;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 40px;
    height: 2px;
    // 匹配 Portal 主色渐变
    background: linear-gradient(90deg, #057bf3, #1a8cff);
    border-radius: 1px;
  }
}

.footer-title-en {
  font-size: 14px;
  // 匹配 Portal 英文标题色
  color: #cdcdcd;
  margin-bottom: 15px;
  text-align: left;
  letter-spacing: 1px;
  text-transform: uppercase;
}

// 文本样式 - 匹配 Portal 正文色
.footer-text {
  color: #656565;
  font-size: 15px;
  margin-bottom: 12px;
  line-height: 26px;
  text-align: left;
}

.footer-text-about {
  line-height: 26px;
  text-align: left;
  // 匹配 Portal 重要文本色
  color: #333333;
}

// 快速链接 - 匹配 Portal 链接样式
.quick-links {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.quick-links li {
  margin-bottom: 10px;
}

.quick-links a {
  // 匹配 Portal 链接默认色
  color: #656565;
  font-size: 15px;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  position: relative;
  padding-left: 8px;

  &:hover {
    // 匹配 Portal hover 主色
    color: #057bf3;
    transform: translateX(4px);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1px;
    // 匹配 Portal 主色渐变
    background: linear-gradient(90deg, #057bf3, #1a8cff);
    transition: width 0.3s ease;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 6px;
    // 匹配 Portal 主色透明背景
    background: rgba(5, 123, 243, 0.2);
    border-radius: 3px;
    transform: translateY(-50%);
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }

  &:hover::before {
    width: 4px;
  }
}

// 二维码容器 - 匹配 Portal 卡片风格
.qrcode-container {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  margin-top: 0;
}

.qrcode-item {
  width: 110px;
  height: auto;
  text-align: center;
  // 匹配 Portal 卡片背景
  background: #f3f5f5;
  padding: 10px;
  border-radius: 8px;
  // 匹配 Portal 边框色
  border: 1px solid #eef2f7;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02), 0 0 8px rgba(5, 123, 243, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05), 0 0 12px rgba(5, 123, 243, 0.2);
    border-color: #057bf3;
  }
}

.qrcode-item img {
  width: 100%;
  height: 90px;
  object-fit: contain;
  margin-bottom: 8px;
  border-radius: 4px;
  background: #ffffff;
}

.qrcode-tip {
  font-size: 13px;
  // 匹配 Portal 次要文本色
  color: #656565;
  margin: 0;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.qrcode-item:hover .qrcode-tip {
  color: #057bf3;
}

// 光效移动动画
@keyframes lightMove {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}


</style>
